/**
 * Muted User Remapper
 * Flutter: lib/data/models/muted_user.dart
 */
import type { MutedUserDto } from '@/data/dtos/mutedUser/mutedUserDto';
import type { JsonObject } from '@/data/types/json';
import type { MutedUserStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class MutedUserRemapper {
  static toStorage(dto: MutedUserDto): MutedUserStorage {
    return {
      firebaseId: dto.firebaseId,
    };
  }

  static fromFirebaseId(firebaseId: string): MutedUserStorage {
    return {
      firebaseId,
    };
  }

  static fromJson(data: JsonObject): MutedUserDto {
    return {
      firebaseId: (data['firebaseId'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): MutedUserDto[] {
    return dataList.map(MutedUserRemapper.fromJson);
  }
}
